// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1Ir-i","list":"styles_list__3LT7l"};